import React from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Form, Header, Input, Button, Icon, TextArea, Divider, Grid, Loader, Segment, Message } from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';
import PropTypes from 'prop-types';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

/**
 * <State>
 * studentLock object that wraps the form information
 *
 * <Props>
 * sendStudentLock(studentLock) - func
 * studentStudyProgramId - number
 * studnetStudyProgramOptLock - number
 * hasThesis - boolean
 */

export default class StudentLockForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            disabled: true,
            marks: [],
            studentLock: {
                diplomaNumber: null,
                limitation: false,
                comment: null,
                additionalActivities: null,
                commentTranslation: null,
                date: this.props.limitation ? null : new Date(),
                theme: null,
                themeEnglish: null,
                thesisComment: null,
                thesisDate: this.props.limitation ? null : new Date(),
                mark: null,

                themeTranslation: null,
                thesisCommentTranslation: null,

                optLock: null,
                thesisId: null,
                thesisOptLock: null,

                thesisPresentationId: null,
                thesisPresentationOptLock: null,

                thesisPresentationMarkId: null,
                thesisPresentationMarkOptLock: null,
            },
            thesis: true,
            confirmation: false,
            confirmationUnlock: false,

            diplomaNumberErr: false,
            themeErr: false,
            markErr: false,
            hideButtons: false,
            notEnrolled: false,
            loader: true,
            sendPfInfo: false,
            isPf: false,
            notPassedCourses: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChange_ = this.handleInputChange_.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.fetchLookups = this.fetchLookups.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.lock = this.lock.bind(this);
        this.checkFinalCourseOnSp = this.checkFinalCourseOnSp.bind(this);
        this.checkOldSpForPf = this.checkOldSpForPf.bind(this);
    }

    componentWillMount() {
        this.checkFinalCourseOnSp();
    }
    componentDidMount() {
        const {
            studyProgramId, studentStudyProgramId
        } = this.props;
        if (localStorage.getItem('activeRole').substr(0, 30) === 'Studentska: Pedagoški fakultet') {
            this.setState({ isPf: true });
            this.checkOldSpForPf(studyProgramId);
        }

        axios.get(`course/basic/not-passed/${studentStudyProgramId}/`)
            .then(res => {
                let courses = res.data ? res.data : [];
                this.setState({
                    notPassedCourses: !!courses.length
                });
            })
            .catch(err => {
                console.log('Failed to fetch not passed courses.');
            });
    }
    checkOldSpForPf(studyProgramId) {
        axios.get(`study-programs/izrada-diplomskog-rada/${studyProgramId}/`).then((res) => {
            if (res.data === true) {
                this.setState({ sendPfInfo: true });
            } else {
                this.setState({ sendPfInfo: false });
            }
        }).catch((err) => {
            console.log('Failed to check old sp!');
        });
    }

    sendAdditionalInfoForPf() {
        axios.post('/grade-student/izrada-diplomskog-rada/', {
            date: this.state.studentLock.date,
            studentStudyProgramId: this.props.studentStudyProgramId
        }).then((res) => {
            console.log('res:', res.data);
        }).catch((err) => {
            console.log('Failed to post additional info for pf!');
        });
    }

    lock() {
        console.log('lock');
        let studentLock = {
            id: this.props.studentStudyProgramId,
            optLock: this.state.studentLock.optLock
        };

        axios.post('/students/lock/', { ...studentLock })
            .then(res => {
                toast('Student je uspješno zaključan.');
                this.props.updateStudentStatuses();
                this.props.toggleLockedVisibility();
                this.fetchData(this.props.studentStudyProgramId);
                this.setState({ hideButtons: true, confirmation: false, confirmationUnlock: false });
            })
            .catch(err => { toast('Došlo je do greške! Student nije zaključan.'); });
    }

    unlock() {
        let studentLock = {
            id: this.props.studentStudyProgramId,
            optLock: this.state.studentLock.optLock
        };

        axios.put(`students/unlock-student-study-program/${this.props.studentStudyProgramId}`)
            .then(res => {
                toast('Student je uspješno otključan.');
                this.props.updateStudentStatuses();
                this.props.toggleLockedVisibility();
                this.fetchData(this.props.studentStudyProgramId);
                this.setState({ hideButtons: false, confirmation: false, confirmationUnlock: false });
            })
            .catch(err => { toast('Došlo je do greške! Student nije otključan.'); });
    }

    fetchLookups() {
        axios.all([axios.get('/marks')])
            .then(axios.spread((marksRes) => {
                const marks = marksRes.data.map(el => ({
                    ...el, value: el.id, key: el.id, text: el.displayName,
                })).filter(el => el.key_ !== 'uo');

                this.setState({
                    marks
                });
            }))
            .catch(err => {
                console.log(err);
            });

        this.fetchData(this.props.studentStudyProgramId);
    }

    fetchData(studentStudyProgramId) {
        let { studentLock } = this.state;
        axios.get(`/students/${studentStudyProgramId}/`)
            .then(res => {
                studentLock = {
                    ...studentLock,
                    optLock: res.data.optLock,
                    diplomaNumber: res.data.diplomaNumber,
                    locked: res.data.locked,
                    comment: res.data.additionalActivities,
                    additionalActivities: res.data.translations[0] && res.data.translations[0].additionalActivities ? res.data.translations[0].additionalActivities : null,
                    date: res.data.diplomaNumber ? res.data.graduationDate ? res.data.graduationDate : null : new Date(),
                    mark: this.state.marks.find(e => e.text === 'uspješno odbranjen').value,

                };

                axios.get((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator') ? `/students/thesis-for-admin/${studentStudyProgramId}/`
                    : `/students/thesis/${studentStudyProgramId}/`)
                    .then(thesisRes => {
                        if (thesisRes.data.length > 0) {
                            if (thesisRes.data[0].theme !== '') { this.setState({ disabled: false }); }
                            studentLock = {
                                ...studentLock,
                                theme: thesisRes.data[0].theme,
                                thesisComment: thesisRes.data[0].comment ? thesisRes.data[0].comment : null,
                                thesisId: thesisRes.data[0].id,
                                thesisOptLock: thesisRes.data[0].optLock,
                                themeEnglish: thesisRes.data[0].translations.length ? thesisRes.data[0].translations[0].theme : null

                            };
                            axios.get(`/students/thesis-presentation/${thesisRes.data[0].id}/`)
                                .then(thesisPresentationRes => {
                                    if (thesisPresentationRes.data.length > 0) {
                                        studentLock = {
                                            ...studentLock,
                                            thesisDate: thesisPresentationRes.data[0].date,
                                            thesisPresentationId: thesisPresentationRes.data[0].id,
                                            thesisPresentationOptLock: thesisPresentationRes.data[0].optLock,
                                        };

                                        axios.get(`/students/thesis-presentation-mark/${thesisPresentationRes.data[0].id}/`)
                                            .then(thesisPresentationMarkRes => {
                                                if (thesisPresentationMarkRes.data.length > 0) {
                                                    studentLock = {
                                                        ...studentLock,
                                                        mark: thesisPresentationMarkRes.data[0].mark.id ? thesisPresentationMarkRes.data[0].mark.id : this.state.marks.find(e => e.text === 'uspješno odbranjen').value,
                                                        thesisPresentationMarkId: thesisPresentationMarkRes.data[0].id,
                                                        thesisPresentationMarkOptLock: thesisPresentationMarkRes.data[0].optLock,
                                                    };

                                                    this.setState({
                                                        studentLock,
                                                        thesis: true,
                                                        loader: false

                                                    });
                                                } else {
                                                    this.setState({
                                                        studentLock,
                                                        thesis: true,
                                                    });
                                                    this.setState({ loader: false });
                                                }
                                            })
                                            .catch(thesisPresentationMarkErr => {
                                                this.setState({
                                                    studentLock,
                                                    thesis: true,
                                                    loader: false
                                                });
                                            });
                                    } else {
                                        this.setState({
                                            studentLock,
                                            thesis: true,
                                        });
                                        this.setState({ loader: false });
                                    }
                                })
                                .catch(thesisPresentationErr => {
                                    this.setState({
                                        studentLock,
                                        thesis: true,
                                    });
                                });
                        } else {
                            this.setState({
                                studentLock,
                                loader: false
                            });
                            console.log('ikkkk');
                        }
                    })
                    .catch(thesisErr => {
                        console.log(thesisErr);
                        this.setState({
                            studentLock,
                        });
                    });
            })
            .catch(err => {
                console.log(err);
            });
    }

    handleInputChange(e, { name, value }) {
        if (name === 'theme') {
            if (value !== '' || value !== '-') { this.setState({ disabled: false }); } else { this.setState({ disabled: true }); }
        }
        this.setState(prevState => ({
            studentLock: {
                ...prevState.studentLock,
                [name]: value,
            },
        }));
    }

    handleInputChange_(event) {
        const { target } = event;
        const { value } = target;
        const { name } = target;

        this.setState({
            [name]: value
        });
    }
    handleDateChange(e, isThesis) {
        if (isThesis) {
            this.setState(prevState => ({
                studentLock: {
                    ...prevState.studentLock,
                    thesisDate: e,
                },
            }));
        } else {
            this.setState(prevState => ({
                studentLock: {
                    ...prevState.studentLock,
                    date: e,
                },
            }));
        }
    }

    handleToggleThesis(isShown) {
        this.setState(prevState => ({
            thesis: isShown,
        }));
    }

    sendStudentLock(studentLock, hasThesis, isLocked) {
        const { theme, mark, diplomaNumber } = this.state.studentLock;

        if (!mark || !diplomaNumber || (!(this.state.disableRight || this.state.disableInput) && !theme)) {
            if (!(this.state.disableRight || this.state.disableInput) && !theme) { this.setState({ themeErr: true }); } else this.setState({ themeErr: false });
            if (!mark) { this.setState({ markErr: true }); } else this.setState({ markErr: false });
            if (!diplomaNumber) { this.setState({ diplomaNumberErr: true }); } else this.setState({ diplomaNumberErr: false });
            toast('Niste unijeli sva obavezna polja!');
            return;
        }

        this.setState({ diplomaNumberErr: false, themeErr: false, markErr: false });
        const {
            studentStudyProgramId,
        } = this.props;
        let studentLockRequest;
        let language = { twoLetterCode: 'en' };
        let translations = [{ additionalActivities: this.state.studentLock.additionalActivities, language }];

        let studentStudyProgram = {
            translations,
            id: studentStudyProgramId,
            optLock: studentLock.optLock,
            diplomaNumber: studentLock.diplomaNumber,
            locked: isLocked ? 1 : 0,
            additionalActivities: studentLock.comment,
            graduationDate: studentLock.date,
        };

        if (hasThesis) {
            let language = { twoLetterCode: 'en' };
            let translations = [{ theme: this.state.studentLock.themeEnglish, language }];
            studentLockRequest = {
                studentStudyProgram,
                thesis: {
                    translations: this.state.studentLock.themeEnglish !== null ? translations : null,
                    theme: studentLock.theme,
                    comment: studentLock.thesisComment,
                    id: studentLock.thesisId,
                    optLock: studentLock.thesisOptLock,
                },
                thesisPresentation: {
                    date: studentLock.thesisDate,
                    id: studentLock.thesisPresentationId,
                    optLock: studentLock.thesisPresentationOptLock,
                },
                thesisPresentationMark: {
                    mark: studentLock.mark ? { id: studentLock.mark } : null,
                    id: studentLock.thesisPresentationMarkId,
                    optLock: studentLock.thesisPresentationMarkOptLock,
                },
            };
        } else {
            studentLockRequest = {
                studentStudyProgram,
            };
        }

        if (studentStudyProgramId === null) {
            return;
        }

        let markObj = {
            markId: studentLock.mark,
            studentStudyProgramId: this.props.studentStudyProgramId,
            date: studentLock.thesisDate
        };

        axios.post('/students/graduation-data/', { ...studentLockRequest })
            .then(res => {
                // eslint-disable-next-line no-unused-expressions
                this.props.updateStudentStatuses();
                this.props.toggleGraduationVisibility();
                hasThesis ? axios.post('/students/graduation-mark/', { ...markObj })
                    .then(re => {
                        toast('Podaci o završetku ciklusa studija su uspješno sačuvani.');
                        this.fetchData(this.props.studentStudyProgramId);
                    }) :
                    toast('Podaci o završetku ciklusa studija su uspješno sačuvani.');

                axios.get(`course/basic/not-passed/${studentStudyProgramId}/`)
                    .then(result => {
                        let courses = result.data ? result.data : [];
                        this.setState({
                            notPassedCourses: !!courses.length
                        });
                    })
                    .catch(err => {
                        console.log('Failed to fetch not passed courses.');
                    });
            })
            .catch(err => {
                toast('Došlo je do greške! Podaci o završetku ciklusa studija nisu sačuvani.');
            });

        if (this.state.sendPfInfo) {
            this.sendAdditionalInfoForPf();
        }
    }
    checkFinalData() {
        const {
            studentStudyProgramId,
        } = this.props;
        axios.get(`course/implementations/final/${studentStudyProgramId}/`).then((res) => {
            if (res.data.length === 0) {
                // nije upisan
                this.setState({ notEnrolled: true, loader: false });
                // this.fetchLookups();
            } else {
                // upisan na zavrsni
                this.setState({ notEnrolled: false });
                this.fetchLookups();
            }
        }).catch((err) => {
            console.log('Failed to check final data!');
            toast('Došlo je do greške! Provjera da li je student upisan na završni rad nije uspjela.');
        });
    }

    checkFinalCourseOnSp() {
        const {
            studentStudyProgramId,
            studyProgramId
        } = this.props;
        axios.get((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'Support')
            ? `study-programs/final-course-existence-check/${studyProgramId}/${localStorage.getItem('orgUnit')}`
            : `study-programs/final-course-existence-check/${studyProgramId}/`)
            .then((res) => {
                if (res.data) {
                // postoji zavrsni, provjeriti da li je upisan student
                    this.setState({ hasFinal: true });
                    this.checkFinalData();
                } else {
                    this.setState({ disableRight: true, hasFinal: false });
                    this.fetchLookups();
                }
            }).catch((err) => {
                console.log('Failed to check final course on sp!');
                toast('Došlo je do greške! Provjera da li sp ima završni rad nije uspjela.');
            });
    }

    render() {
        const {
            diplomaNumber,
            comment,
            additionalActivities,
            date,
            theme,
            themeEnglish,
            thesisDate,
            mark,
            thesisComment,
        } = this.state.studentLock;
        const { notPassedCourses } = this.state;
        return (
            <div>

                {notPassedCourses && <Message
                    warning
                > <Icon name="warning sign" color="brown" /><b>Student ima nepoloženih predmeta.</b></Message>}
                <Grid columns="equal" centered className="stackable">
                    {this.state.loader ?
                        <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>

                        : <Grid.Row streched>
                            <Grid.Column>
                                <Divider horizontal>
                                    <Header as="h4">Podaci o diplomiranju<br />
                                        <span style={{ fontSize: '13px', fontWeight: 'normal' }}><i>Ovi podaci se prikazuju na dodatku diplomi.</i></span>
                                    </Header>
                                </Divider>
                                <Segment clearing secondary>
                                    <Form>
                                        <Form.Group widths="equal">
                                            <Form.Field
                                                readOnly={this.props.limitation}
                                                required
                                                label="Broj izdate diplome"
                                                disabled={this.state.notEnrolled}
                                                control={Input}
                                                name="diplomaNumber"
                                                value={diplomaNumber}
                                                onChange={this.handleInputChange}
                                                placeholder="Unesite broj diplome"
                                                error={this.state.diplomaNumberErr}

                                            />
                                            <Form.Field
                                                readOnly={this.props.limitation}
                                                control={DateTimePicker}
                                                label="Datum diplomiranja"
                                                format="D. M. YYYY."
                                                time={false}
                                                disabled={this.state.notEnrolled}
                                                onChange={(e) => this.handleDateChange(e, false)}
                                                value={date ? new Date(date) : null}
                                                style={{ borderWidth: '0px' }}
                                            />
                                        </Form.Group>
                                        <Form.Field
                                            readOnly={this.props.limitation}
                                            label="Dodatne informacije"
                                            control={TextArea}
                                            name="comment"
                                            rows={5}
                                            value={comment}
                                            defaultValue={comment}
                                            disabled={this.state.notEnrolled}
                                            onChange={this.handleInputChange}
                                            placeholder="Unesite dodatne informacije"
                                        />
                                        <Form.Field
                                            readOnly={this.props.limitation}
                                            label="Dodatne informacije na engleskom jeziku"
                                            control={TextArea}
                                            name="additionalActivities"
                                            rows={5}
                                            value={additionalActivities}
                                            defaultValue={additionalActivities}
                                            disabled={this.state.notEnrolled}
                                            onChange={this.handleInputChange}
                                            placeholder="Unesite dodatne informacije na engleskom jeziku"
                                        />

                                    </Form></Segment>
                            </Grid.Column>
                            <Grid.Column>
                                <Divider horizontal>
                                    <Header as="h4">Podaci o završnom radu <br />

                                        {
                                            this.state.hasFinal ?
                                                (!this.state.loader && this.state.notEnrolled) ?
                                                    <span style={{ fontSize: '13px', fontWeight: 'normal', color: 'red' }}><i>Student nije upisan na diplomski (završni) rad!</i></span>
                                                    :
                                                    <span style={{ fontSize: '13px', fontWeight: 'normal' }}><i>Podaci o diplomskom (završnom) radu.</i></span>
                                                :
                                                <span style={{ fontSize: '13px', fontWeight: 'normal' }}><i>Studijski program nema diplomski (završni) rad.</i></span>
                                        }
                                    </Header>

                                </Divider>

                                <Segment clearing secondary>
                                    <Form >
                                        <Form.Field
                                            readOnly={this.props.limitation}
                                            required={!(this.state.disableRight || this.state.notEnrolled)}
                                            error={this.state.themeErr}

                                            label="Tema"
                                            control={TextArea}
                                            disabled={this.state.disableRight || this.state.notEnrolled}
                                            name="theme"
                                            rows={2}
                                            value={theme}
                                            onChange={this.handleInputChange}
                                            placeholder="Unesite temu"
                                        />
                                        <Form.Field
                                            readOnly={this.props.limitation}
                                            label="Tema na engleskom jeziku"
                                            control={TextArea}
                                            disabled={this.state.disableRight || this.state.notEnrolled}
                                            name="themeEnglish"
                                            rows={2}
                                            value={themeEnglish}
                                            onChange={this.handleInputChange}
                                            placeholder="Unesite temu na engleskom jeziku"
                                        />
                                        <Form.Group widths="equal">
                                            <Form.Field
                                                readOnly={this.props.limitation}
                                                disabled={this.state.disableRight || this.state.notEnrolled}
                                                control={DateTimePicker}
                                                label="Datum odbrane"
                                                format="D. M. YYYY."
                                                time={false}
                                                onChange={(e) => this.handleDateChange(e, true)}
                                                value={thesisDate ? new Date(thesisDate) : null}
                                                style={{ borderWidth: '0px' }}
                                            />
                                            {this.props.limitation ?
                                                <Form.Field
                                                    readOnly
                                                    required
                                                    disabled={this.state.disableRight || this.state.notEnrolled}
                                                    label="Ocjena"
                                                    control={Input}
                                                    name="mark"
                                                    value={mark ? this.state.marks.find(el => el.id === mark).name : null}
                                                />
                                                : <Form.Dropdown
                                                    required
                                                    label="Ocjena"
                                                    placeholder="Odaberite ocjenu"
                                                    value={mark}
                                                    onChange={this.handleInputChange}
                                                    name="mark"
                                                    options={this.state.marks}
                                                    disabled={this.state.disableRight || this.state.notEnrolled}
                                                    search
                                                    fluid
                                                    selection
                                                    error={this.state.markErr}
                                                />}
                                        </Form.Group>
                                        <Form.Field
                                            readOnly={this.props.limitation}
                                            label="Dodatne informacije"
                                            control={TextArea}
                                            rows={2}
                                            name="thesisComment"
                                            disabled={this.state.disableRight || this.state.notEnrolled}
                                            value={thesisComment}
                                            onChange={this.handleInputChange}
                                            placeholder="Unesite dodatne informacije"
                                        />

                                    </Form>
                                </Segment>

                            </Grid.Column>
                        </Grid.Row>}

                </Grid>

                <Divider />
                {(this.props.locked && (localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator')) ?
                    this.state.confirmationUnlock ?
                        <div style={{ float: 'left' }}>
                            <h4>Jeste li sigurni?</h4>
                            <Button.Group >
                                <Button
                                    basic="true"
                                    color="blue"
                                    onClick={
                                        () => {
                                            this.unlock();
                                        }
                                    }
                                > DA</Button>
                                <Button
                                    basic="true"
                                    color="red"
                                    onClick={() => { this.setState({ confirmationUnlock: false }); }}
                                >  NE

                                </Button>
                            </Button.Group></div> :
                        <Button
                            floated="left"
                            icon
                            labelPosition="left"
                            color="teal"
                            onClick={
                                () => {
                                    this.setState({ confirmationUnlock: true });
                                }
                            }
                        ><Icon className="lock open" />Otključaj studenta</Button> : null}
                {(!this.props.limitation && !this.state.hideButtons) && <div clearing>
                    <Button
                        disabled={this.state.notEnrolled || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Support' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                        floated="right"
                        color="blue"
                        onClick={
                            () => {
                                this.sendStudentLock(this.state.studentLock, !this.state.disabled, false);
                            }
                        }
                    >Sačuvaj podatke</Button>
                    {this.state.confirmation ?
                        <div style={{ float: 'left' }}>
                            <h4>Jeste li sigurni?</h4>
                            <Button.Group >
                                <Button
                                    basic="true"
                                    color="blue"
                                    onClick={this.lock}
                                > DA</Button>
                                <Button
                                    basic="true"
                                    color="red"
                                    onClick={() => { this.setState({ confirmation: false }); }}
                                >  NE

                                </Button>
                            </Button.Group></div>
                        : this.state.hideButtons ? null :
                        <Button
                                disabled={!this.props.graduationDate || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Support' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                                floated="left"
                                icon
                                labelPosition="left"
                                color="red"
                                onClick={
                                    () => {
                                        this.setState({ confirmation: true });
                                    }
                                }
                            ><Icon className="lock" />Zaključaj studenta</Button>
                    }
                    <br /><br /></div>}
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}

StudentLockForm.defaultProps = {
    sendStudentLock: (studentLock) => {
        axios.post('/students/lock/', { ...studentLock })
            .then(toast('Student je uspješno zaključan.'))
            .catch(toast('Došlo je do greške! Student nije zaključan.'));
    },
    studentStudyProgramId: null,
};

StudentLockForm.propTypes = {
    sendStudentLock: PropTypes.func,
    studentStudyProgramId: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/StudentLockForm.js